const BASE = process.env.REACT_APP_BACKEND_URL;

async function request(path, { method = 'GET', body, headers = {} } = {}) {
  const res = await fetch(`${BASE}/api${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', ...headers },
    body: body ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) {
    const message = data?.detail || `Request failed (${res.status})`;
    throw new Error(typeof message === 'string' ? message : JSON.stringify(message));
  }
  return data;
}

export const api = {
  chapterRequest: (payload) => request('/chapter-request', { method: 'POST', body: payload }),
  prayer: (payload) => request('/prayer', { method: 'POST', body: payload }),
  exercise: (payload) => request('/exercise', { method: 'POST', body: payload }),
  adminVerify: (password) => request('/admin/verify', { method: 'POST', headers: { 'X-Admin-Password': password } }),
  adminCounts: (password) => request('/admin/counts', { headers: { 'X-Admin-Password': password } }),
  adminSubmissions: (password, kind) =>
    request(`/admin/submissions${kind ? `?kind=${kind}` : ''}`, { headers: { 'X-Admin-Password': password } }),
};

export const PDF_URL = '/gasoline-chapter-1-sample.pdf';
